export type BlackoutFlags = {
    eventGlobalFlag: '1' | '0' | undefined;
    eventPlatformFlag: '1' | '0' | undefined;
    channelGlobalFlag: '1' | '0' | undefined;
    channelPlatformFlag: '1' | '0' | undefined;
};

function isPlaybackBlackedOut({
    eventGlobalFlag,
    eventPlatformFlag,
    channelGlobalFlag,
    channelPlatformFlag,
}: BlackoutFlags) {
    const enabledByEventFlags =
        eventGlobalFlag === '0' && eventPlatformFlag === '0';
    const enabledByEventPlatformFlag =
        eventGlobalFlag == null &&
        channelGlobalFlag !== '1' &&
        eventPlatformFlag === '0';
    const enabledByChannelPlatformFlag =
        eventGlobalFlag === '0' &&
        eventPlatformFlag == null &&
        channelPlatformFlag === '0';
    const enabledByChannelFlagsOnly =
        eventGlobalFlag == null &&
        channelGlobalFlag !== '1' &&
        eventPlatformFlag == null &&
        channelPlatformFlag === '0';

    return !(
        enabledByEventFlags ||
        enabledByEventPlatformFlag ||
        enabledByChannelPlatformFlag ||
        enabledByChannelFlagsOnly
    );
}

export default isPlaybackBlackedOut;
